import { useEffect } from 'react';

/** Calls `handler` on a `mousedown` outside the element held by `ref`. The
 * listener is only attached while `enabled` is true (typically the open state
 * of a dropdown/menu), and is torn down on cleanup. The handler is read fresh
 * on each event via the effect closure, so it always sees the latest props. */
function useClickOutside(ref, handler, enabled = true) {
  useEffect(() => {
    if (!enabled) {
      return undefined;
    }
    const onMouseDown = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        handler(event);
      }
    };
    document.addEventListener('mousedown', onMouseDown);
    return () => document.removeEventListener('mousedown', onMouseDown);
  }, [ref, handler, enabled]);
}

export default useClickOutside;
